import React, { createRef, useState, useEffect, useCallback } from 'react';
import { UserProvider } from '../context/UserContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/site.scss';
import '../assets/css/media.scss';
import '../adminAssets/css/dashboard.css';
import authService from '../services/authServices';
import AdminSidebarFilter from './partial/adminSidebarFilter';
// import AdminHeader from './partial/adminHeader';
import logo from '../adminAssets/images/Lovrican-Logo_2.svg';
import AdminLeftMenu from './partial/adminLeftMenu';

const InnerLayoutAdmin = (props) => {
  const { children, history } = props;

  const dashboardRef = createRef();
  const sidebarRef = createRef();

  const [isLeftMenuVisible, setIsLeftMenuVisible] = useState(false);
  const [isMobileView, setIsMobileView] = useState(
    window.matchMedia('(max-width: 768px)').matches
  );

  useEffect(() => {
    authService.throwBackAdmin(history);

    // Optional: Add media query listener for responsive behavior
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const handleMediaChange = (e) => setIsMobileView(e.matches);

    mediaQuery.addEventListener('change', handleMediaChange);

    return () => {
      mediaQuery.removeEventListener('change', handleMediaChange);
    };
  }, [history]);

  const toggleFilterButtonHandler = useCallback(() => {
    if (sidebarRef.current) {
      sidebarRef.current.toggleVisibilityMethod();
    }
  }, [sidebarRef]);

  const searchUsersCallbackHandler = useCallback((data) => {
    if (dashboardRef.current) {
      dashboardRef.current.searchUsersHandlerMethod(data);
    }
  }, [dashboardRef]);

  const toggleLeftMenu = useCallback(() => {
    setIsLeftMenuVisible(prev => !prev);
  }, []);

  // Clone children and pass the ref and handler
  const childrenWithRef = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        ref: dashboardRef,
        onFilterBtnClickHandler: toggleFilterButtonHandler
      });
    }
    return child;
  });

  return (
    <UserProvider>
      <div className="dashboard_admin">
        <header className='mobile_header_view'>
          <div className='burger-menu'>
            {/* eslint-disable-next-line */}
            <div className='burger' onClick={toggleLeftMenu} role='button'>
              <span />
              <span />
              <span />
            </div>
          </div>
          <div className='logo'>
            <img className="logo" src={logo} alt="logo" />
          </div>
        </header>

        {/* <AdminHeader {...props} onFilterBtnClickHandler={toggleFilterButtonHandler} /> */}

        <AdminLeftMenu
          leftMenuToggleHandler={toggleLeftMenu}
          isLeftMenuVisible={isLeftMenuVisible}
          isMobileView={isMobileView}
        />
        <AdminSidebarFilter
          {...props}
          ref={sidebarRef}
          searchUsersCallbackHandler={searchUsersCallbackHandler}
        />
        <section className="admin_container">
          {childrenWithRef}
        </section>
      </div>
    </UserProvider>

  );
};

export default InnerLayoutAdmin;
